import { render, staticRenderFns } from "./DanhSachVaiTroTheoGroup.vue?vue&type=template&id=ee97c286&scoped=true&"
import script from "./DanhSachVaiTroTheoGroup.vue?vue&type=script&lang=js&"
export * from "./DanhSachVaiTroTheoGroup.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachVaiTroTheoGroup.vue?vue&type=style&index=0&id=ee97c286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee97c286",
  null
  
)

export default component.exports